import { benefitSelectionTypes } from "constants/benefitSelection";
import { useMemo } from "react";
import { setRows } from "store/slices/serviceDetails";
import { ProcedureRow } from "types/CreateOrder";

import { StyledDropdown } from "./styled";

const benefitOptions = [
  { value: null, label: "Default Benefit" },
  { value: "SELF_PAY", label: "Not Covered / Self-Pay" },
  { value: "COINSURANCE_APPLIES", label: "Co-insurance Applies" },
];

const benefitOptionsGFE = [
  { value: null, label: "Default Benefit" },
  { value: "SELF_PAY", label: "Not Covered / Self-Pay" },
  { value: "COINSURANCE_APPLIES", label: "Co-insurance Applies" },
  { value: "REQUIRES_ABN", label: "Requires ABN" },
  // CLE-2659: prices exactly like "Not Covered / Self-Pay" and also collects an ABN signature.
  {
    value: benefitSelectionTypes.SELF_PAY_WITH_ABN,
    label: "Not Covered / Self-Pay + ABN",
  },
];

const preventiveOption = { value: "PREVENTIVE", label: "Preventive" };

export function BenefitCell({
  row,
  rows,
  dispatch,
  isGFE,
}: {
  row: ProcedureRow;
  rows: ProcedureRow[];
  dispatch: any;
  isGFE: boolean;
}) {
  const benefitOptionsForRow = useMemo(() => {
    const base = isGFE ? benefitOptionsGFE : benefitOptions;
    const isPreventiveAvailable = rows.some(
      (r) => r.cptCode === row.cptCode && r.preventive
    );
    return isPreventiveAvailable ? [...base, preventiveOption] : base;
  }, [isGFE, rows, row.cptCode]);

  const denefitValue = useMemo(() => {
    const rowsWithSameCPTCode = rows.filter((r) => r.cptCode === row.cptCode);
    const hasPreventiveSelectionType = rowsWithSameCPTCode.some(
      (r) => r.benefitSelectionType === "PREVENTIVE"
    );
    const hasAbnSelfPaySelectionType = rowsWithSameCPTCode.some(
      (r) => r.benefitSelectionType === benefitSelectionTypes.SELF_PAY_WITH_ABN
    );
    const hasAbnSelectionType = rowsWithSameCPTCode.some(
      (r) => r.benefitSelectionType === "REQUIRES_ABN"
    );

    // Same precedence as the fee-schedule defaults (builders.tsx).
    if (hasPreventiveSelectionType) return "PREVENTIVE";
    if (hasAbnSelfPaySelectionType)
      return benefitSelectionTypes.SELF_PAY_WITH_ABN;
    if (hasAbnSelectionType) return "REQUIRES_ABN";
    return row.benefitSelectionType || null;
  }, [row.benefitSelectionType, rows]);

  const onBenefitChange = (e: { value: string | null }) => {
    // Update all rows with the same CPT code to have the same benefit selection
    const newRows = [...rows].map((r) => {
      if (r.cptCode === row.cptCode) {
        return {
          ...r,
          benefitSelectionType: e.value,
        };
      }
      return r;
    });
    dispatch(setRows(newRows));
  };

  return (
    <StyledDropdown
      className="w-full"
      value={denefitValue}
      options={benefitOptionsForRow}
      onChange={onBenefitChange}
      placeholder="Default Benefit"
      data-testid="benefitSelection_GFEServiceDetails"
    />
  );
}
